<app-back forcedRoute="/consultations" [setClass]="'btn'" class="back" [text]="'COMMON.GO_BACK'"></app-back>
<router-outlet></router-outlet>